import { Button } from "react-bootstrap";
import { useIntl } from "react-intl";
import { BulkNetlinkingContainer, BulkSiloContainer } from "src/app/containers";
import SeoByAiButtonContainer from "../SeoByAiButton/SeoByAiButtonContainer";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "src/_metronic/helpers/AssetHelpers";
import UpsertSiteFormBodyModalContainer from "../UpsertSiteFormBodyModal/UpsertSiteFormBodyModalContainer";
import { useState } from "react";

export interface OffSiteButtonContainerProps {
    selectedRows?: Array<any>;
    moneySiteId?: number;
    hasAccess?: boolean;
}

const OffSiteButtonsContainer = (props: OffSiteButtonContainerProps) => {
    const { selectedRows, hasAccess, moneySiteId } = props;
    const [editModal, setEditModal] = useState(false);

    const handleEditModal = () => {
        setEditModal(!editModal);
    };
    const handleClose = () => {
        setEditModal(false);
    };

    const { formatMessage } = useIntl();

    return (
        <>
            <div>
                <span className="d-flex fw-bold-800 text-uppercase justify-content-center form-label">
                    {formatMessage({ id: "common.button.order" })}
                </span>

                <div className="d-flex gap-2">
                    <div className="gap-2 buttonWrapper">
                        {hasAccess ? (
                            <>
                                <BulkNetlinkingContainer selectedRows={selectedRows} />
                                <BulkSiloContainer selectedRows={selectedRows} />
                            </>
                        ) : (
                            <div style={{ flexGrow: 1 }} />
                        )}
                        <SeoByAiButtonContainer moneySiteId={moneySiteId} />
                    </div>
                    <div className="d-flex flex-column justify-content-between buttonWrapper">
                        {hasAccess ? (
                            <Button
                                className="d-flex align-content-center align-items-center justify-content-center px-3 btn-primary"
                                style={{ height: "43.56px" }}
                            >
                                <SVG
                                    style={{ height: "36px", width: "36px" }}
                                    src={toAbsoluteUrl("/media/icons/personal/google.svg")}
                                />
                            </Button>
                        ) : (
                            <div style={{ flexGrow: 1 }} />
                        )}

                        <Button
                            className="d-flex align-content-center align-items-center justify-content-center px-3 btn-primary"
                            style={{ height: "43.56px" }}
                            onClick={handleEditModal}
                        >
                            <SVG src={toAbsoluteUrl("/media/icons/duotune/general/gen055.svg")} />
                        </Button>
                        {moneySiteId && (
                            <UpsertSiteFormBodyModalContainer
                                showModal={editModal}
                                handleClose={handleClose}
                                entity={{
                                    id: moneySiteId,
                                }}
                            />
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default OffSiteButtonsContainer;
